import { makeAutoObservable } from "mobx";

class PrefillStore {
  suggestions = [];
  showBanner = false;
  showModal = false;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setSuggestions = (matches) => (this.suggestions = matches);

  setShowBanner = (v) => (this.showBanner = v);

  setShowModal = (v) => (this.showModal = v);

  setLoading = (v) => (this.loading = v);

  dismiss = () => {
    this.showBanner = false;
    this.showModal = false;
  };

  reset = () => {
    this.suggestions = [];
    this.showBanner = false;
    this.showModal = false;
    this.loading = false;
  };
}

export const prefillStore = new PrefillStore();
